import { Fragment } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Privacidad = () => {
    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        #title-header{
                            background-image: url(/assets/images/2.jpg);
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <main className="main">

                <div id="title-header" class="page-title dark-background" data-aos="fade">
                    <div class="container position-relative">
                        <h1>Aviso de privacidad</h1>
                    </div>
                </div>

                {/* Privacidad */}
                <section id="privacy" class="privacy section">
                    <div class="container" data-aos="fade-up">
                        <div class="privacy-header" data-aos="fade-up">
                            <div class="header-content">
                                <div class="last-updated">Última actualización: 12-01-2026</div>
                                <p class="intro-text">
                                    El presente Aviso de Privacidad describe cómo Bela María recaba, utiliza, almacena y protege los
                                    datos personales de los usuarios que acceden y utilizan nuestros servicios, instalaciones y
                                    plataforma digital.
                                </p>
                            </div>
                        </div>

                        <div class="privacy-content" data-aos="fade-up">

                            <div class="content-section">
                                <h2>1. Introducción</h2>
                                <p>
                                    En Bela María reconocemos la importancia de la protección de sus datos personales y asumimos el
                                    compromiso de tratarlos de forma responsable, confidencial y conforme a la legislación aplicable.
                                </p>
                                <p>
                                    Este Aviso de Privacidad tiene como finalidad informarle qué datos recopilamos, con qué fines los
                                    utilizamos y cómo puede ejercer sus derechos como titular de los datos.
                                </p>
                            </div>

                            <div class="content-section">
                                <h2>2. Datos personales que se recaban</h2>
                                <p>
                                    Para la correcta prestación de nuestros servicios, Bela María podrá recabar los siguientes datos
                                    personales:
                                </p>

                                <h3>2.1 Datos proporcionados por el usuario</h3>
                                <ul>
                                    <li>Nombre y apellidos</li>
                                    <li>Teléfono y correo electrónico</li>
                                    <li>Datos de acceso a la cuenta (usuario y contraseña)</li>
                                    <li>Información relacionada con citas, paquetes y membresías</li>
                                </ul>

                                <h3>2.2 Información recopilada de forma automática</h3>
                                <ul>
                                    <li>Datos de navegación y uso del sitio web</li>
                                    <li>Información técnica del dispositivo y navegador</li>
                                    <li>Dirección IP y datos estadísticos</li>
                                </ul>
                            </div>

                            <div class="content-section">
                                <h2>3. Finalidades del tratamiento de los datos</h2>
                                <p>
                                    Los datos personales recabados serán utilizados para las siguientes finalidades:
                                </p>
                                <ul>
                                    <li>Registro y administración de cuentas de usuario</li>
                                    <li>Gestión de citas, paquetes y membresías</li>
                                    <li>Comunicación relacionada con los servicios contratados</li>
                                    <li>Acceso y uso de instalaciones y amenidades</li>
                                    <li>Mejora de la experiencia del usuario y calidad del servicio</li>
                                </ul>
                            </div>

                            <div class="content-section">
                                <h2>4. Transferencia de datos personales</h2>
                                <p>
                                    Bela María no comparte ni transfiere datos personales a terceros, salvo en los siguientes casos:
                                </p>

                                <h3>4.1 Consentimiento del titular</h3>
                                <p>
                                    Cuando el titular haya otorgado su consentimiento expreso para la transferencia de sus datos.
                                </p>

                                <h3>4.2 Obligaciones legales</h3>
                                <p>
                                    Cuando sea requerido por autoridades competentes o para cumplir con disposiciones legales
                                    aplicables.
                                </p>
                            </div>

                            <div class="content-section">
                                <h2>5. Seguridad de los datos</h2>
                                <p>
                                    Bela María implementa medidas de seguridad administrativas, técnicas y físicas para proteger los
                                    datos personales contra daño, pérdida, alteración, destrucción o uso no autorizado.
                                </p>
                                <ul>
                                    <li>Protección de accesos a sistemas internos</li>
                                    <li>Uso de conexiones seguras</li>
                                    <li>Restricción de acceso a información sensible</li>
                                </ul>
                            </div>

                            <div class="content-section">
                                <h2>6. Derechos ARCO</h2>
                                <p>
                                    El titular de los datos personales tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al
                                    tratamiento de sus datos personales (Derechos ARCO).
                                </p>
                                <ul>
                                    <li>Acceder a sus datos personales</li>
                                    <li>Solicitar la corrección de información inexacta</li>
                                    <li>Solicitar la cancelación de sus datos</li>
                                    <li>Oponerse al uso de sus datos para fines específicos</li>
                                </ul>
                            </div>

                            <div class="content-section">
                                <h2>7. Cambios al Aviso de Privacidad</h2>
                                <p>
                                    Bela María se reserva el derecho de modificar el presente Aviso de Privacidad en cualquier momento.
                                    Las modificaciones serán publicadas en este sitio web.
                                </p>
                                <p>
                                    El uso continuo de la plataforma implica la aceptación del Aviso de Privacidad actualizado.
                                </p>
                            </div>
                        </div>

                        <div class="privacy-contact" data-aos="fade-up">
                            <h2>Contacto</h2>
                            <p>
                                Para cualquier duda, aclaración o solicitud relacionada con este Aviso de Privacidad, puede
                                comunicarse con nosotros a través de los siguientes medios:
                            </p>
                            <div class="contact-details">
                                <p><strong>Teléfono:</strong> 449 580 0092</p>
                                <p><strong>Dirección:</strong> Montes Himalaya #406, Bosques del Prado, Aguascalientes</p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </Fragment>
    )
}

export default Privacidad;